import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import DateRangePicker from '../../commonComponents/DateRangePicker';
import DateSelector from '../../commonComponents/DateSelector';
import { FiltersCard, StyledInput, StyledSelect, FiltersRow } from './styles';
import { STATUS_FILTER_OPTIONS } from './constants';
import type { OrderFiltersSectionProps } from './types';

const OrderFiltersSection: React.FC<OrderFiltersSectionProps> = ({
  searchTerm,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  showHistoryFilters,
  selectedDateRange,
  onDateRangeChange,
  onDateSelect,
}) => (
  <FiltersCard>
    <FiltersRow>
      <StyledInput
        placeholder="Search by name..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        prefix={<FontAwesomeIcon icon={faSearch} className="search-prefix-icon" />}
        allowClear
      />
      <StyledSelect
        value={statusFilter || 'all'}
        onChange={onStatusFilterChange}
        options={STATUS_FILTER_OPTIONS?.map((opt) => ({ value: opt?.value, label: opt?.label }))}
        popupStyle={{ minWidth: 220 }}
        popupClassName="orders-status-select-dropdown"
      />
      {showHistoryFilters && (
        <>
          <DateRangePicker
            selectedDateRange={selectedDateRange}
            onDateRangeChange={onDateRangeChange}
            placeholder="Select date range"
          />
          <DateSelector onDateSelect={onDateSelect} />
        </>
      )}
    </FiltersRow>
  </FiltersCard>
);

export default OrderFiltersSection;
